
import {
	LOCATION,
	FETCH_LOADING,
	HOTELSTORE,
	DEFAULTDATE,
	BRANDLIST,
	HOTELDETAIL,
	SCROLLTOP,
	BMAPLOCATION,
	ROOMNUMBER,
	COVER,
	VALIDATEFORM,
	KEYS

} from './mutations-type.js'
import { setLocalStorage } from '@/utils/index.js'

const mutations = {
	FETCH_LOADING (state, fetchLoading) {
		state.fetchLoading = fetchLoading
	},
	LOCATION (state, location) {
		setLocalStorage('city', location)
		state.location = {...location}
	},
	HOTELSTORE (state, hotel) {
		state.hotel = hotel
	},
	DEFAULTDATE (state, data) {
		setLocalStorage('pickDate', data)
		state.defaultDate = {...data}
	},
	BRANDLIST (state, data) {
		state.brandList = data
		setLocalStorage('brand', data)
	},
	HOTELDETAIL (state, data) {
		state.hotelDetail[data.key] = {...data.value}
	},
	SCROLLTOP (state, data) {
		state.scrollTop = data
	},
	BMAPLOCATION (state, location) {
		state.bmap = {...location}
	},
	ROOMNUMBER (state, data) {
		state.roomNumber = {...data}
		setLocalStorage('roomNumber', data)
	},
	COVER (state, status) {
		state.cover = status
	},
	VALIDATEFORM (state, data) {
		if (JSON.stringify(data) === '{}') {
			state.validateForm = {}
		} else {
			state.validateForm = {...state.validateForm, ...data}
		}
	},
	KEYS (state, key) {
		state.keys = [...key]
	}
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js